export function parseUTC(strDate){
    if(typeof strDate !== "string") return undefined;

    if(strDate[strDate.length - 1] !== "Z")
        strDate = strDate + "Z";

    return new Date(strDate);
}


// WEBPACK FOOTER //
// ./src/utils/date.js